import { render, staticRenderFns } from "./ProcessedMadeupView.vue?vue&type=template&id=a5597646&scoped=true"
import script from "./ProcessedMadeupView.vue?vue&type=script&lang=js"
export * from "./ProcessedMadeupView.vue?vue&type=script&lang=js"
import style0 from "./ProcessedMadeupView.vue?vue&type=style&index=0&id=a5597646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5597646",
  null
  
)

export default component.exports